<template>
    <div>
        <v-row no-gutters class="pt-2 pl-2">
            <v-col cols="8" class="pr-1">
                <v-card class="elevation-0 pb-0 fill-height" style="background: transparent">
                    <DocumentMenu 
                        v-if="!['EDITION'].includes(declaration.status) && windowStep === 0"
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @duplicate="duplicate()"
                        @edit="openConfirmationDialog()"
                        @regenerate="reComputeAccountingLines()"
                        @display-accounting-line="setStep(1)"
                        @update="updateDeclarationStatus()"
                        @activity="displayActivityDialog = true"
                    />
                    <v-row
                        no-gutters
                        class="default_card_wm d-flex align-center"
                        v-else-if="!['EDITION'].includes(declaration.status) && windowStep !== 0"
                    >
                        <v-col cols="10">
                            <v-btn-back class="ml-1" @click.stop="back()"> </v-btn-back>
                        </v-col>
                        <!--
                        <v-col
                            cols="2"
                            v-if="windowStep === 0"
                            class="d-flex justify-center align-center"
                        >
                            <v-btn
                                rounded
                                elevation="0"
                                @click.stop="duplicate()"
                                size="small"
                                class="px-2"
                            >
                                Dupliquer
                            </v-btn>
                            <v-menu offset-y v-if="windowStep === 0">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" class="mx-1" />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        @click="openConfirmationDialog()"
                                        :disabled="!declaration.document && !documentId"
                                    >
                                        <v-list-item-title>Modifier l'OD</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-edit</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="reComputeAccountingLines()"
                                        :disabled="isInsideClosedAccountingPeriod"
                                    >
                                        <v-list-item-title>Regénérer l'OD</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon
                                                size="small"
                                                :disabled="isInsideClosedAccountingPeriod"
                                                >$fa-redo-alt</v-icon
                                            >
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="setStep(1)"
                                        :disabled="!declaration.document && !documentId"
                                    >
                                        <v-list-item-title
                                            >Afficher les lignes comptables</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon size="small">$fa-list</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item @click="updateDeclarationStatus()">
                                        <v-list-item-title
                                            >Mettre à jour le statut</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon size="small">$fa-redo-alt</v-icon>
                                        </template>
                                    </v-list-item>
                                    <TaxFormEDIReport
                                        :disabled="!mtaeStatusOk"
                                        :taxFormId="declaration.id"
                                        :isDeclaration="true"
                                    >
                                        <template #default="{ statusOk, mtaeProof }">
                                            <v-list-item :disabled="!statusOk" @click="mtaeProof">
                                                <v-list-item-title
                                                    >Impression justificatif EDI</v-list-item-title
                                                >
                                                <template v-slot:append>
                                                    <v-icon size="small">$oss-download</v-icon>
                                                </template>
                                            </v-list-item>
                                        </template>
                                    </TaxFormEDIReport>
                                    <v-list-item
                                        @click="displayActivityDialog = true"
                                        v-if="isAccountingUser && declaration && declaration.id"
                                    >
                                        <v-list-item-title>Afficher l'activité</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <!-- <v-list-item>
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <v-list-item-action>
                                            <v-icon small>$oss-trash</v-icon>
                                        </v-list-item-action>
                                    </v-list-item> -->
                                    <!--
                                </v-list>
                            </v-menu>
                        -->
                        <v-col cols="12" class="d-flex justify-end">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$fa-redo-alt"
                                        color="primary"
                                        v-bind="props"
                                        @click="reComputeAccountingLines()"
                                    />
                                </template>
                                <span>Regénérer l'OD</span>
                            </v-tooltip>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        color="primary"
                                        class="ml-2"
                                        v-bind="props"
                                        @click="openConfirmationDialog()"
                                    />
                                </template>
                                <span>Modifier l'OD</span>
                            </v-tooltip>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$oss-close"
                                        color="primary"
                                        class="ml-2"
                                        v-bind="props"
                                        @click="setStep(0)"
                                    />
                                </template>
                                <span>Fermer</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-window v-model="windowStep">
                                <v-window-item :key="0">
                                    <DeclarationForm
                                        v-if="declaration"
                                        :decId="declaration.id"
                                        :declaration="declaration"
                                        :formId="declaration.form.id"
                                        :hide-header="!['EDITION'].includes(declaration.status)"
                                    >
                                    </DeclarationForm>
                                </v-window-item>
                                <v-window-item
                                    :key="1"
                                    class="pt-2"
                                    v-if="declaration.document || documentId"
                                >
                                    <accounting-item-static
                                        :companyId="companyId"
                                        :documentId="
                                            declaration.document
                                                ? declaration.document.id
                                                : documentId
                                        "
                                        mode="Embedded"
                                        ref="accountingItemStatic"
                                    />
                                </v-window-item>
                            </v-window>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="4" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        height: 90vh;
                        overflow-y: auto;
                    "
                    class="default_card_wm elevation-0"
                >
                    <v-card-text class="pt-0">
                        <v-list single-line class="pt-2 pb-0" density="compact">
                            <v-list-item :ripple="false" class="mb-2 rounded-xl" color="success">
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>Nom</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between align-center text-wrap"
                                        >
                                            {{ form.name }} (Millésime {{ form.year }})
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item :ripple="false" class="mb-2 rounded-xl" color="success">
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>Cerfa</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between text-wrap align-center"
                                        >
                                            {{ form.cerfaNumber }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :ripple="false"
                                class="mb-2 rounded-xl"
                                color="success"
                                v-if="declaration.status === 'SENT'"
                            >
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>Déclaré</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between text-wrap align-center"
                                        >
                                            {{
                                                newCommonFormatCurrency(
                                                    declaration.amountDeclared || 0,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :ripple="false"
                                class="mb-2 rounded-xl"
                                color="success"
                                v-if="paymentsInfo"
                            >
                                <v-list-item-title class="body-1 pb-4">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>Payé</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between text-wrap align-center"
                                        >
                                            {{ paymentsInfo.amountPaid }}
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        v-for="payment in paymentsInfo.paymentsList"
                                        :key="payment.iban"
                                        class="pl-6"
                                    >
                                        <v-col
                                            >{{ payment.amount }} &#x20ac; / {{ payment.iban }} /
                                            {{ payment.bic }}</v-col
                                        >
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item :ripple="false" class="mb-2 rounded-xl" color="success">
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>Statut</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between align-center text-wrap"
                                        >
                                            {{ translateStatus(declaration) }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :ripple="false"
                                class="mb-2 rounded-xl"
                                color="success"
                                v-if="displayDate()"
                            >
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>Date</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between align-center"
                                        >
                                            {{ displayDate() }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="declaration.mtaeId"
                                :ripple="false"
                                class="mb-2 rounded-xl"
                                color="success"
                            >
                                <v-list-item-title class="body-1">
                                    <v-row no-gutters class="align-center">
                                        <v-col cols="3" style="border-right: 1px #ededed solid">
                                            <b>EDI N&#xb0;</b>
                                        </v-col>
                                        <v-col
                                            cols="9"
                                            class="pl-2 d-flex justify-space-between text-wrap align-center"
                                        >
                                            {{ declaration.mtaeId }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="declarationErrors.length"
                                :ripple="false"
                                class="rounded-xl"
                            >
                                <v-list-item-title class="body-1">
                                    <b>Erreurs</b>
                                </v-list-item-title>
                                <v-row no-gutters class="py-1">
                                    <div
                                        cols="11"
                                        v-for="(error, index) in declarationErrors"
                                        :key="index"
                                    >
                                        <div
                                            class="d-flex justify-start font-weight-bold text-wrap py-4 px-4"
                                        >
                                            {{ error.num }} - {{ error.detail }}
                                        </div>
                                    </div>
                                </v-row>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions />
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog v-model="miscellaneousOperationDialog" :actions="actionsMiscellaneousOperation">
            <div style="width: 1100px">
                <AccountingItemEdition2
                    v-if="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :documentId="declaration.document ? declaration.document.id : documentId"
                    :actions="actionsMiscellaneousOperation"
                >
                </AccountingItemEdition2>
            </div>
        </oss-dialog>
        <oss-dialog v-model="confirmationDialog" title="Confirmation" @valid="confirm()">
            <v-row no-gutters style="width: 750px">
                <v-col cols="12" class="d-flex justify-center">
                    <div class="pt-2 px-4 pb-2">
                        En modifiant l'écriture manuellement, vous perdrez le lien entre la
                        déclaration et l'OD de TVA.
                    </div>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="displayActivityDialog"
            v-if="displayActivityDialog"
            title="Activité"
            valid-title="Fermer"
            width="60%"
            @valid="displayActivityDialog = false"
            @close="displayActivityDialog = false"
        >
            <UsersActivitiesHistory :declarationId="declaration.id"> </UsersActivitiesHistory>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import moment from "moment-timezone";

import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";
import { DialogAction } from "@/services/dialogAction";

import DeclarationForm from "./DeclarationForm.vue";
import AccountingItemStatic from "../../AccountingItemStatic.vue";
import AccountingItemEdition2 from "../../accounting/accountingItem/Edition.vue";
import UsersActivitiesHistory from "@/views/UsersActivitiesHistory.vue";

import UPSERT_DECLARATION from "@/graphql/declaration/UpsertDeclaration.gql";
import DECLARATIONFORM from "@/graphql/declarationForm/DeclarationForm.gql";
import UPDATE_DECLARATIONS_STATUS from "@/graphql/declaration/UpdateDeclarationsStatus.gql";
import UPDATE_DECLARATION_MO from "@/graphql/declaration/UpdateDeclarationAccountingLines.gql";
import RESTORE_DOCUMENT from "@/graphql/document/RestoreDocument.gql";

import TaxFormEDIReport from "../TaxFormEDIReport.vue";
import { getPaymentsFromXml } from "@/services/declaration/declarationServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { isInsideClosedAccountingPeriod } from "@/services/accountingPeriods";
import { User } from "@/store/store";

import { MenuDisplayDotMenuOptions, MenuDisplayDuplicateOptions, MenuDisplayOptions } from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";
import { DocumentMenu } from "@/views/document/DocumentMenu.vue";

@Component({
    components: {
        DeclarationForm,
        AccountingItemStatic,
        AccountingItemEdition2,
        TaxFormEDIReport,
        UsersActivitiesHistory,
        DocumentMenu
    },
    emits: ["updateDeclarationStatus"],
})
export class DocumentDeclaration extends Vue {
    @Prop({ default: null }) declaration: any;

    windowStep: string | number = "declaration";

    othersInfoExtend = false;

    miscellaneousOperationDialog: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    confirmationDialog: boolean = false;

    displayActivityDialog: boolean = false;

    get documentMenuDuplicateOptions(): MenuDisplayDuplicateOptions {
        const duplicateOptions: MenuDisplayDuplicateOptions = { ...documentMenuDisplayOptionsDefaultScheme.duplicate };

        duplicateOptions.isDisplay = true;
        duplicateOptions.title = "Dupliquer";

        return duplicateOptions;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = { ...documentMenuDisplayOptionsDefaultScheme.dotMenu };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.edit.isDisplay = true;
        dotMenuOptions.edit.disabled = !this.declaration.document && !this.documentId;
        dotMenuOptions.edit.title = "Modifier l'OD";

        dotMenuOptions.regenerate.isDisplay = true;
        dotMenuOptions.regenerate.title = "Regénérer l'OD";
        dotMenuOptions.regenerate.disabled = this.isInsideClosedAccountingPeriod;

        dotMenuOptions.accountingLine.isDisplay = true;
        dotMenuOptions.accountingLine.disabled = !this.declaration.document && !this.documentId;
        dotMenuOptions.accountingLine.title = "Afficher les lignes comptables";

        dotMenuOptions.update.isDisplay = true;
        dotMenuOptions.update.title = "Mettre à jour le statut";

        dotMenuOptions.updateMTAE.isDisplay = true;
        dotMenuOptions.updateMTAE.title = "Impression justificatif EDI";
        dotMenuOptions.updateMTAE.disabled = !this.mtaeStatusOk;
        dotMenuOptions.updateMTAE.taxformId = this.declaration.id;
        dotMenuOptions.updateMTAE.isDeclaration = true;

        dotMenuOptions.activity.isDisplay = this.isAccountingUser && this.declaration && this.declaration.id;
        dotMenuOptions.activity.title = "Afficher l'activité";

        return dotMenuOptions;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = { ...documentMenuDisplayOptionsDefaultScheme }

        documentMenuOption.duplicate = this.documentMenuDuplicateOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions

        return documentMenuOption;
    }

    @Apollo({
        query: DECLARATIONFORM,
        variables() {
            return {
                id: this.declaration?.form.id,
            };
        },
        skip() {
            return !this.declaration?.form?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.declarationForm) {
                    this.form = data.declarationForm;
                }
            }
        },
    })
    form: any = {};

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get formatedInfoList() {
        let list = [];
        if (this.declaration.mtaeData) {
            for (const attribute of Object.keys(this.declaration.mtaeData)) {
                list.push(
                    ...Object.entries(this.declaration.mtaeData[attribute]).map((x) => ({
                        title: `${attribute}-${x[0]}`,
                        value: x[1],
                    })),
                );
            }
        }
        return list;
    }

    get declarationErrors() {
        const errors = [];

        if (this.declaration?.mtaeData?.erreur?.length) {
            for (const err of this.declaration.mtaeData.erreur) {
                errors.push({ num: err.numErreur, detail: err.texte });
            }
        } else if (
            !this.declaration?.mtaeData?.erreur?.length &&
            this.declaration?.status === "ERROR"
        ) {
            errors.push({ num: "N/A", detail: "" });
        }
        return errors;
    }

    get xml() {
        return this.declaration?.data?.file || null;
    }

    get paymentsInfo() {
        if (this.declaration.status === "SENT" && this.xml) {
            const payments = getPaymentsFromXml(this.xml);
            if (payments?.amountPaid > 0) {
                return {
                    paymentsList: payments.paymentsList,
                    amountPaid: newCommonFormatCurrency(payments.amountPaid, undefined),
                };
            }
        }
        return null;
    }

    back() {
        this.$router.push({ name: "taxForms" });
    }

    async duplicate() {
        await this.$apollo.mutate({
            mutation: UPSERT_DECLARATION,
            variables: {
                id: "",
                data: this.declaration.data,
                companyId: this.companyId,
                declarationFormId: this.form.id,
                status: "EDITION",
                accountingPeriodId: this.declaration.accountingPeriod.id,
                startDate: moment(this.declaration.startDate).utc(true).format(),
                endDate: moment(this.declaration.endDate).utc(true).format(),
            },
        });
    }

    setStep(step: string | number) {
        this.windowStep = step;
    }

    translateStatus(declaration) {
        switch (declaration.status) {
            case "EDITION":
                return "En cours d'édition";
            case "SENT":
                if (!declaration.mtaeStatus) {
                    return "Validée sans envoi";
                }
                if (declaration.mtaeStatus !== "OK") {
                    return declaration.mtaeStatus;
                }
                return "Envoyée";
            case "ERROR":
                return declaration.mtaeStatus;
            default:
                return "Inconnu";
        }
    }

    // displayDate() {
    //     return this.declaration?.date.format("DD/MM/YYYY")
    // }

    displayDate() {
        return this.declaration?.date ? moment(this.declaration.date).format("DD/MM/YYYY") : "";
    }

    async updateDeclarationStatus() {
        await this.$apollo.mutate({
            mutation: UPDATE_DECLARATIONS_STATUS,
            variables: {
                ids: [this.declaration.id],
            },
        });
        if (this.$apollo?.queries?.form) {
            await this.$apollo.queries.form.refetch();
            this.$emit("updateDeclarationStatus");
        }
    }

    async reComputeAccountingLines() {
        // for a validated or definitely deleted document
        const data = await this.$apollo.mutate({
            mutation: UPDATE_DECLARATION_MO,
            variables: {
                id: this.declaration.id,
            },
        });
        // for the reactivity
        if (data) {
            this.documentId = data.data.updateDeclarationAccountingLines.documentId;
        }
        //
        // for a lightly deleted document
        if (this.declaration.document && this.declaration.document.id) {
            await this.$apollo.mutate({
                mutation: RESTORE_DOCUMENT,
                variables: {
                    id: this.declaration.document.id,
                    status: "VALIDATED",
                },
            });
        }
    }
    documentId: string = null;

    openConfirmationDialog() {
        this.confirmationDialog = true;
    }

    confirm() {
        if (this.windowStep === 0) {
            this.miscellaneousOperationDialog = true;
        } else {
            this.openAccountingItemEditionDialog();
        }
        this.confirmationDialog = false;
    }

    openAccountingItemEditionDialog() {
        // @ts-ignore
        if (this.$refs.accountingItemStatic) {
            // @ts-ignore
            this.$refs.accountingItemStatic.openEditDialog();
        }
    }

    get mtaeStatusOk() {
        if (!this.declaration || !this.declaration.status) {
            return false;
        }
        if (
            (this.declaration.status === "SENT" && this.declaration.mtaeId) ||
            this.declaration.status === "ERROR"
        ) {
            return true;
        } else {
            return false;
        }
    }

    get mtaeId() {
        return this.declaration.mtaeId;
    }

    get periodDocument(): string {
        if (this.declaration.startDate === this.declaration.endDate) {
            return this.formatDate(this.declaration.startDate);
        }
        return `${this.formatDate(this.declaration.startDate)} - ${this.formatDate(this.declaration.endDate)}`;
    }

    formatDate(date: string) {
        return moment(date).format("D MMM YYYY");
    }

    isStatutDeclaration() {
        if (this.declaration.status === "SENT") {
            if (!this.declaration.mtaeStatus) {
                return "Déclaration validée sans envoi";
            }
            if (this.declaration.mtaeStatus !== "OK") {
                return this.declaration.mtaeStatus;
            }
            return "Déclaration envoyée";
        }
        if (this.declaration.status === "EDITION") {
            return "Déclaration en cours d'édition";
        }
        if (this.declaration.status === "VALIDATED_NOT_SENT") {
            return "Déclaration validée sans envoi";
        }
        if (this.declaration.status === "ERROR") {
            return this.declaration.mtaeStatus;
        }
    }

    isStatutDateValidate() {
        let formattedDate = "";
        if (
            (this.declaration.status === "SENT" && this.declaration.mtaeId) ||
            this.declaration.status === "ERROR"
        ) {
            const currentDate = new Date();
            formattedDate = moment(currentDate).format("DD/MM/YYYY");
        } else {
            return this.isStatutDeclaration();
        }
        return formattedDate;
    }

    get dateSend() {
        const dateString = this.declaration.date;
        return moment(dateString).format("DD/MM/YYYY HH:mm");
    }

    get processingDate() {
        const dateString = this.declaration?.mtaeData?.statut?.dateTraitementDGFiP;
        if (dateString) {
            return moment(dateString).format("DD/MM/YYYY");
        }
        return "Pas encore traité";
    }

    get isInsideClosedAccountingPeriod() {
        if (this.declaration?.document?.date) {
            return isInsideClosedAccountingPeriod(this.$store, this.declaration.document.date);
        }
        return false;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }
}

export default toNative(DocumentDeclaration);
</script>

<style>
.transparent-background {
    background-color: transparent !important;
}

.transparent-background :hover {
    background-color: transparent !important;
}
</style>
